import { api } from './api.js';
import { TAG_LIST_PROJECTS, TAG_PROJECT } from './tags.js';
import { convertToUrlSearchParams } from '../utils/helper.js';

export const projectsEndpoints = api.injectEndpoints({
    endpoints: (builder) => ({
        getProjects: builder.query({
            query: (params) => {
                return {
                    url: `/projects?${convertToUrlSearchParams(params)}`,
                    method: 'GET'
                };
            },
            providesTags: [TAG_LIST_PROJECTS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getProject: builder.query({
            query: (id) => ({
                url: `/projects/view/${id}`,
                method: 'GET'
            }),
            providesTags: [TAG_PROJECT],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        editProject: builder.mutation({
            query: ({ id, data }) => ({
                url: `/projects/edit/${id}`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_PROJECTS, TAG_PROJECT],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        addProject: builder.mutation({
            query: (data) => ({
                url: '/projects/add',
                method: 'POST',
                body: data
            }),
            invalidatesTags: [TAG_LIST_PROJECTS, TAG_PROJECT],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        getProjectStatuses: builder.query({
            query: () => ({
                url: '/misc/project-statuses',
                method: 'GET'
            }),
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `/projects/delete/${id}`,
                method: 'DELETE'
            }),
            invalidatesTags: [TAG_LIST_PROJECTS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        }),
        projectsAdvancedSearch: builder.query({
            query: (params) => ({
                url: `/projects/search?${convertToUrlSearchParams(params)}`,
                method: 'GET'
            }),
            providesTags: [TAG_LIST_PROJECTS],
            async onQueryStarted(_, { queryFulfilled }) {
                await queryFulfilled;
            }
        })
    })
});

export const {
    useLazyGetProjectsQuery,
    useGetProjectQuery,
    useEditProjectMutation,
    useAddProjectMutation,
    useGetProjectStatusesQuery,
    useDeleteProjectMutation,
    useLazyProjectsAdvancedSearchQuery
} = projectsEndpoints;
